import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { IConnectContact } from '@epicuro-next/data/connect';
import { ConnectionStatus } from '@epicuro-next/models/users';

@Component({
  selector: 'epc-contact-list',
  templateUrl: './contact-list.component.html',
  styleUrls: ['./contact-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ContactListComponent {
  public ConnectionStatus = ConnectionStatus;

  @Output()
  public call = new EventEmitter<IConnectContact>();

  @Input()
  public contacts: IConnectContact[];

  @Input()
  public userCalling = false;

  public initCall(contact: IConnectContact) {
    this.call.emit(contact);
  }
}
